import React from 'react';


const Footer = () => {
    return (
        <div className="w-full h-[200px] bg-[#1E293B] flex flex-col items-center justify-center">
            <p className="text-base text-white">@Scan to Google Sheets. All rights reserved</p>
        </div>
    )
}

export default Footer;